<main>
    <div id="fade" (click)="close()"></div>
    <div id="modal" [style.width]="witdhModal">
        <ng-content></ng-content>
    </div>
</main>
